<template>
    <div class="main-content" v-loading="fullScreenLoading">
        <avue-crud ref="crud" :data="tableData" :option="option" :table-loading="showLoading" :page.sync="page"
            @on-load="onLoad" @selection-change="handleSelectedChange">
            <!-- 搜索框-->
            <template #header>
                <div>
                    <div class="flex flex-wrap align-items marginBottom20">
                        <div class="flex align-items marginRight10 marginBottom10">
                            <span class="span marginRight10 width80 textAlignRight">模型名称 :
                            </span>
                            <div class="width300">
                                <el-input v-model="searchData.name" placeholder="请输入模型名称" clearable
                                    maxlength="50" @keyup.enter.native="handleSearch"></el-input>
                            </div>
                        </div>
                        <div class="flex align-items marginRight10 marginBottom10">
                            <span class="span marginRight10 width80 textAlignRight">模型路径 :
                            </span>
                            <div class="width300">
                                <el-input v-model="searchData.path" placeholder="请输入模型路径" clearable
                                    maxlength="200" @keyup.enter.native="handleSearch"></el-input>
                            </div>
                        </div>
                        <div class="flex align-items marginRight10 marginBottom10">
                            <span class="span marginRight10 width80 textAlignRight">创建时间 :
                            </span>
                            <div class="width300">
                                <el-date-picker v-model="searchData.createTime" type="daterange" range-separator="至"
                                    start-placeholder="开始日期" end-placeholder="结束日期" :clearable="true">
                                </el-date-picker>
                            </div>
                        </div>
                        <el-button size="medium" type="primary" @click="handleSearch" style="margin-bottom: 10px"
                            class="marginLeft10">搜索</el-button>
                        <el-button size="medium" type="info" @click="handleReset" class="marginLeft10"
                            style="margin-bottom: 10px">重置</el-button>
                        <el-button size="medium" type="primary" @click="handleAdd" class="marginLeft10"
                            style="margin-bottom: 10px">新增</el-button>
                        <el-button size="medium" type="danger" @click="handleBatchDelete" class="marginLeft10"
                            style="margin-bottom: 10px" :disabled="selectedRows.length === 0">批量删除</el-button>
                    </div>
                </div>
            </template>
            <!-- 操作菜单 -->
            <template slot="menu" slot-scope="{ row }">
                <el-button type="text" size="mini" @click="handleEdit(row)">编辑</el-button>
                <el-button type="text" size="mini" @click="handleDelete(row)">删除</el-button>
            </template>
        </avue-crud>

        <!-- 新增/编辑弹框 -->
        <el-dialog 
            :title="dialogForm.title" 
            :visible.sync="dialogForm.visible" 
            width="500px"
            :before-close="handleDialogClose">
            <el-form 
                ref="modelForm" 
                :model="dialogForm.form" 
                :rules="dialogForm.rules" 
                label-width="100px">
                <el-form-item label="模型名称" prop="name">
                    <el-input 
                        v-model="dialogForm.form.name" 
                        placeholder="请输入模型名称"
                        maxlength="100"
                        show-word-limit
                        clearable>
                    </el-input>
                </el-form-item>
                <el-form-item label="模型路径" prop="path">
                    <el-input 
                        v-model="dialogForm.form.path" 
                        placeholder="请输入模型路径"
                        maxlength="200"
                        show-word-limit
                        type="textarea"
                        :rows="3"
                        clearable>
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleDialogClose">取消</el-button>
                <el-button 
                    type="primary" 
                    :loading="dialogForm.loading"
                    @click="handleDialogSubmit">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import dayjs from "dayjs";
import { modelAiList, modelAiAdd, modelAiUpdate, modelAiDelete } from "@/api/waveform/model";

export default {
    name: "index",
    components: {
    },
    data() {
        return {
            tableData: [],// 表格数据
            // 表格配置项
            option: {
                title: "",
                titleSize: "h3",
                card: false,
                border: true,
                header: false,
                stripe: false, // 显示斑马纹
                showHeader: true, // 显示表头
                index: false, // 显示索引
                indexLabel: "序号", // 索引文字
                size: "small",
                page: true, // 显示分页
                selection: true, // 显示多选框
                tip: false,
                align: "center",
                menuAlign: "center",
                menuType: "text",
                menuFixed: 'right',
                menuWidth: 200,
                editBtn: false,
                delBtn: false,
                maxHeight: 550,
                column: [
                    {
                        label: "模型名称",
                        prop: "name",
                    },
                    {
                        label: "模型路径",
                        prop: "path",
                        width: "500"
                    },
                    {
                        label: "创建时间",
                        prop: "createTime",
                    },
                    {
                        label: "更新时间",
                        prop: "updateTime",
                    }
                ],
            },
            showLoading: false,// 表格加载状态
            // 分页配置项
            page: {
                total: 0,
                currentPage: 1,
                pageSize: 10
            },
            // 搜索数据
            searchData: {
                name: "",
                path: "",
                createTime: "",
            },
            fullScreenLoading: false, // 全屏加载状态
            selectedRows: [], // 选中的行数据
            // 弹框表单
            dialogForm: {
                visible: false,
                title: '',
                loading: false,
                form: {
                    id: '',
                    name: '',
                    path: ''
                },
                rules: {
                    name: [
                        { required: true, message: '请输入模型名称', trigger: 'blur' },
                        { min: 1, max: 50, message: '模型名称长度不能超过100位', trigger: 'blur' }
                    ],
                    path: [
                        { required: true, message: '请输入模型路径', trigger: 'blur' },
                        { min: 1, max: 200, message: '模型路径长度不能超过200位', trigger: 'blur' }
                    ]
                }
            }
        }
    },

    mounted() {
        this.fullScreenLoading = true;
        this.onLoad();
    },

    methods: {
        onLoad() {
            this.showLoading = true;
            const searchData = {
                page: this.page.currentPage,
                size: this.page.pageSize,
                name: this.searchData.name || '',
                path: this.searchData.path || '',
            };
            
            // 处理时间范围
            if (this.searchData.createTime && this.searchData.createTime.length === 2) {
                searchData.startTime = dayjs(this.searchData.createTime[0]).format("YYYY-MM-DD 00:00:00");
                searchData.endTime = dayjs(this.searchData.createTime[1]).format("YYYY-MM-DD 23:59:59");
            }
            
            modelAiList(searchData).then((res) => {
                this.showLoading = false;
                this.fullScreenLoading = false;
                if (res.code === 200) {
                    this.tableData = res.data.records || res.data.list || [];
                    this.page.total = res.data.total || 0;
                }
            }).catch(() => {
                this.showLoading = false;
                this.fullScreenLoading = false;
            });
        },
        
        // 表格多选框选中
        handleSelectedChange(selection) {
            this.selectedRows = selection;
        },
        
        // 查询
        handleSearch() {
            this.fullScreenLoading = true;
            this.page.currentPage = 1;
            this.onLoad();
        },
        
        // 重置
        handleReset() {
            this.searchData = {
                name: "",
                path: "",
                createTime: "",
            };
            this.page.currentPage = 1;
            this.fullScreenLoading = true;
            this.onLoad();
        },

        // 编辑
        handleEdit(row) {
            this.dialogForm.title = '编辑模型';
            this.dialogForm.form = {
                id: row.id,
                name: row.name,
                path: row.path
            };
            this.dialogForm.visible = true;
            // 清除表单验证
            this.$nextTick(() => {
                if (this.$refs.modelForm) {
                    this.$refs.modelForm.clearValidate();
                }
            });
        },

        // 通用删除方法
        handleDeleteCommon(items, isBatch = false) {
            let confirmMessage, successMessage, ids;
            
            if (isBatch) {
                // 批量删除
                if (items.length === 0) {
                    this.$message.warning('请选择要删除的数据');
                    return;
                }
                const selectedNames = items.map(row => row.name).join('、');
                ids = items.map(row => row.id).join(',');
                confirmMessage = `确定删除选中的${items.length}个模型吗？\n${selectedNames}`;
                successMessage = `成功删除${items.length}个模型`;
            } else {
                // 单个删除
                ids = items.id;
                confirmMessage = `确定删除模型"${items.name}"吗？`;
                successMessage = '删除成功';
            }

            this.$confirm(confirmMessage, '删除确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                dangerouslyUseHTMLString: false
            }).then(() => {
                // 调用删除接口
                modelAiDelete(ids).then((res) => {
                    if (res.code === 200) {
                        this.$message.success(successMessage);
                        if (isBatch) {
                            // 清空选中状态
                            this.selectedRows = [];
                        }
                        // 重新加载列表
                        this.onLoad();
                    }
                }).catch((error) => {
                    console.error('删除API调用失败:', error);
                    console.error('错误详情:', error.message, error.stack);
                    this.$message.error('删除失败，请重试');
                });
            }).catch((error) => {
                console.log('用户取消删除或确认框出错:', error);
                // 用户取消删除
            });
        },

        // 单个删除
        handleDelete(row) {
            this.handleDeleteCommon(row, false);
        },

        // 批量删除
        handleBatchDelete() {
            this.handleDeleteCommon(this.selectedRows, true);
        },

        // 新增
        handleAdd() {
            this.dialogForm.title = '新增模型';
            this.dialogForm.form = {
                id: '',
                name: '',
                path: ''
            };
            this.dialogForm.visible = true;
            // 清除表单验证
            this.$nextTick(() => {
                if (this.$refs.modelForm) {
                    this.$refs.modelForm.clearValidate();
                }
            });
        },

        // 关闭弹框
        handleDialogClose() {
            this.dialogForm.visible = false;
            this.dialogForm.loading = false;
            // 重置表单
            this.dialogForm.form = {
                id: '',
                name: '',
                path: ''
            };
            // 清除表单验证
            if (this.$refs.modelForm) {
                this.$refs.modelForm.clearValidate();
            }
        },

        // 提交表单
        handleDialogSubmit() {
            this.$refs.modelForm.validate((valid) => {
                if (valid) {
                    this.dialogForm.loading = true;
                    
                    const submitData = {
                        name: this.dialogForm.form.name,
                        path: this.dialogForm.form.path
                    };

                    // 判断是新增还是编辑
                    const isEdit = !!this.dialogForm.form.id;
                    
                    if (isEdit) {
                        // 编辑模式
                        submitData.id = this.dialogForm.form.id;
                        
                        modelAiUpdate(submitData).then((res) => {
                            this.dialogForm.loading = false;
                            if (res.code === 200) {
                                this.$message.success('编辑成功');
                                this.handleDialogClose();
                                this.onLoad(); // 重新加载列表
                            } else {
                                this.$message.error(res.msg || '编辑失败');
                            }
                        }).catch((error) => {
                            this.dialogForm.loading = false;
                            this.$message.error('编辑失败，请重试');
                            console.error('编辑模型失败:', error);
                        });
                    } else {
                        // 新增模式
                        modelAiAdd(submitData).then((res) => {
                            this.dialogForm.loading = false;
                            if (res.code === 200) {
                                this.$message.success('新增成功');
                                this.handleDialogClose();
                                this.onLoad(); // 重新加载列表
                            } else {
                                this.$message.error(res.msg || '新增失败');
                            }
                        }).catch((error) => {
                            this.dialogForm.loading = false;
                            this.$message.error('新增失败，请重试');
                            console.error('新增模型失败:', error);
                        });
                    }
                } else {
                    this.$message.warning('请填写完整信息');
                }
            });
        }
    }
}
</script>

<style scoped>
.fault_box_label {
    margin-right: 10px;
}

.dialog-footer {
    text-align: right;
}

.dialog-footer .el-button {
    margin-left: 10px;
}

:deep(.el-dialog__body) {
    padding: 20px;
}

:deep(.el-form-item__label) {
    font-weight: 500;
}

/* 批量删除按钮样式 */
.el-button--danger:disabled {
    background-color: #f5f7fa;
    border-color: #e4e7ed;
    color: #c0c4cc;
}

.el-button--danger:not(:disabled):hover {
    background-color: #f56c6c;
    border-color: #f56c6c;
}
</style>